<div class="bg-gray-100 flex min-h-screen items-center flex-col justify-center">
  <div class="bg-white px-20 py-16 rounded-md flex flex-col gap-3 items-center">
    <img src="/images/logo.svg" alt="" class="h-16 pointer-events-none select-none">
    <h1 class="text-2xl font-bold">Benvenuto in CTM</h1>
    <button class="button mt-6" (click)="loginRedirect()">Accedi
    </button>
  </div>
</div>
